'use client'

import { useSyncExternalStore } from 'react'

const noSubscription = () => () => {}

/**
 * `true` só no navegador depois da hidratação (no servidor e na hidratação, `false`): evita erro de hidratação em
 * quem lê dado que só existe no navegador (store persistida, por exemplo).
 */
export function useHasMounted(): boolean {
    return useSyncExternalStore(
        noSubscription,
        () => true,
        () => false,
    )
}
